import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { RunStepDebugPreview } from '@/types/runDebug.ts';
import { RUN_STEP_DEBUG_PREVIEW_KEY } from '@/utils/queryKeys.ts';
import { get_run_step_debug_preview_url } from '@/utils/urls.ts';

const useRetrieveRunStepDebugPreview = ({
  runId,
  stepId,
  fullPath,
  stepRunId,
  enabled = true,
}: {
  runId?: string;
  stepId?: string;
  fullPath?: string | null;
  stepRunId?: string;
  enabled?: boolean;
}): UseQueryResult<RunStepDebugPreview, AxiosError> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();

  return useQuery({
    queryKey: RUN_STEP_DEBUG_PREVIEW_KEY(automationId, runId, stepId, fullPath, stepRunId),
    queryFn: async () => {
      const response = await apiClient.get<RunStepDebugPreview>(
        get_run_step_debug_preview_url({ runId, stepId, fullPath, stepRunId }),
      );
      return response.data;
    },
    enabled: !!runId && !!stepId && enabled,
  });
};

export default useRetrieveRunStepDebugPreview;
